/**
 * ============================================================
 * delivery-validator.js
 * Validador de Zona de Entrega Express — Lalena's Food
 * ============================================================
 *
 * Lógica:
 *   Compara el código postal ingresado contra una lista fija
 *   de ZIPs cubiertos por el radio de 9 millas desde la tienda.
 *   No requiere API externa ni clave de acceso.
 *
 * Tienda: 389 Carrington Dr, Weston, FL 33326
 * ============================================================
 */
(function () {
  'use strict';

  var AUTO_OPEN_STORAGE_KEY = 'dv-modal-shown-session';
  var _dvScrollY = 0;

  // ─────────────────────────────────────────────────────────────────────────────
  // LISTA DE CÓDIGOS POSTALES CUBIERTOS
  // ─────────────────────────────────────────────────────────────────────────────
  // Para actualizar la cobertura: agrega o elimina ZIPs de este array.
  // Cada entrada debe ser un string de exactamente 5 dígitos.
  // ─────────────────────────────────────────────────────────────────────────────
  var EXPRESS_DELIVERY_ZIPS = [
    '33326', // Weston (tienda)
    '33327', // Weston
    '33331', // Weston
    '33325', // Weston
    '33323', // Sunrise
    '33330', // Weston / Southwest Ranches
    '33324', // Davie
    '33028', // Pembroke Pines
    '33322', // Sunrise / Plantation
    '33328', // Davie
    '33388', // Plantation (PO Boxes)
    '33026', // Hollywood / Pembroke Pines
    '33332', // Weston
    '33351', // Lauderhill / Sunrise
    '33029'  // Hollywood / Pembroke Pines
  ];

  var MSG = {};

  // ─────────────────────────────────────────────────────────────────────────────
  // Nota: las tildes y ñ se usan como \uXXXX para máxima compatibilidad
  // en entornos donde el servidor no declara charset=UTF-8 correctamente.
  //   á = \u00e1  é = \u00e9  í = \u00ed  ó = \u00f3  ú = \u00fa
  //   Ó = \u00d3  ¡ = \u00a1
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // HELPERS DE MODAL
  // ─────────────────────────────────────────────────────────────────────────────
  function getModal() {
    return document.getElementById('dv-modal');
  }

  function loadMessages() {
    var modal = getModal();
    if (!modal) return;

    MSG.success = modal.getAttribute('data-dv-success') || '';
    MSG.notCovered = modal.getAttribute('data-dv-not-covered') || '';
    MSG.invalidFormat = modal.getAttribute('data-dv-invalid-format') || '';
    MSG.disclaimer = modal.getAttribute('data-dv-disclaimer') || '';
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;

    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    _dvScrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.top = '-' + _dvScrollY + 'px';
    document.body.classList.add('dv-no-scroll');

    // Limpiar estado anterior
    var zipInput = document.getElementById('dv-zip-input');
    var resultEl = document.getElementById('dv-result');
    if (zipInput) zipInput.value = '';
    if (resultEl) {
      resultEl.innerHTML = '';
      resultEl.className = 'dv-result';
    }

    // Enfocar el input una vez que la animación CSS ha terminado
    setTimeout(function () {
      if (zipInput) zipInput.focus();
    }, 60);
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dv-no-scroll');
    document.body.style.top = '';
    window.scrollTo(0, _dvScrollY);
  }

  function shouldAutoOpen() {
    var modal = getModal();
    if (!modal || modal.getAttribute('data-dv-auto-open') !== 'true') return false;

    try {
      return window.sessionStorage.getItem(AUTO_OPEN_STORAGE_KEY) !== 'true';
    } catch (err) {
      return true;
    }
  }

  function markAutoOpenShown() {
    try {
      window.sessionStorage.setItem(AUTO_OPEN_STORAGE_KEY, 'true');
    } catch (err) {}
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // LÓGICA DE VALIDACIÓN
  // ─────────────────────────────────────────────────────────────────────────────
  function buildResult(cssModifier, iconHtml, message, showDisclaimer) {
    var disclaimerHtml = showDisclaimer
      ? '<p class="dv-result__disclaimer">' + MSG.disclaimer + '<\/p>'
      : '';
    return {
      className: 'dv-result ' + cssModifier,
      html:
        '<p class="dv-result__message">' + iconHtml + message + '<\/p>' +
        disclaimerHtml
    };
  }

  function runValidation() {
    var zipInput = document.getElementById('dv-zip-input');
    var btn      = document.getElementById('dv-validate-btn');
    var resultEl = document.getElementById('dv-result');
    if (!zipInput || !btn || !resultEl) return;

    var zip = zipInput.value.trim();
    var result;

    // 1. Validar formato: exactamente 5 dígitos numéricos
    if (!/^\d{5}$/.test(zip)) {
      result = buildResult(
        'dv-result--error',
        '<span class="dv-result__icon" aria-hidden="true">&#9888;&#xFE0E;&nbsp;<\/span>',
        MSG.invalidFormat,
        false
      );
      resultEl.className = result.className;
      resultEl.innerHTML = result.html;
      return;
    }

    // 2. Deshabilitar botón durante la comparación (aunque sea instantánea,
    //    previene doble clic en dispositivos lentos)
    btn.disabled = true;

    // 3. Comparar contra la lista de ZIPs cubiertos
    var inZone = EXPRESS_DELIVERY_ZIPS.indexOf(zip) !== -1;

    if (inZone) {
      result = buildResult(
        'dv-result--success',
        '<span class="dv-result__icon" aria-hidden="true">&#10003;&nbsp;<\/span>',
        MSG.success,
        true
      );
    } else {
      result = buildResult(
        'dv-result--error',
        '<span class="dv-result__icon" aria-hidden="true">&#10007;&nbsp;<\/span>',
        MSG.notCovered,
        true
      );
    }

    resultEl.className = result.className;
    resultEl.innerHTML = result.html;

    // Re-habilitar el botón
    btn.disabled = false;
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // REGISTRO DE EVENTOS (delegación — compatible con carga dinámica de DOM)
  // ─────────────────────────────────────────────────────────────────────────────
  function init() {
    var modal = getModal();
    console.log('[Lalenas] delivery-validator.js cargado — modal encontrado:', !!modal);
    if (modal) {
      console.log('[Lalenas] delivery-validator: auto-open attr =', modal.getAttribute('data-dv-auto-open'));
    }
    loadMessages();

    document.addEventListener('click', function (e) {
      var t = e.target;
      var openTrigger = t && t.closest ? t.closest('[data-dv-open]') : null;
      var closeTrigger = t && t.closest ? t.closest('[data-dv-close]') : null;

      // Botón que abre el modal
      if (openTrigger) {
        console.log('[Lalenas] delivery-validator: abriendo modal vía', openTrigger.tagName, openTrigger.className);
        openModal();
        return;
      }

      // Botón × que cierra el modal
      if (closeTrigger) {
        closeModal();
        return;
      }

      // Clic en el backdrop (overlay, no en el cuadro interior)
      if (t && t.id === 'dv-modal') {
        closeModal();
        return;
      }

      // Botón de validación
      if (t && t.id === 'dv-validate-btn') {
        runValidation();
        return;
      }
    });

    // Tecla Escape cierra el modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    // Tecla Enter dentro del input lanza la validación
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.id === 'dv-zip-input') {
        e.preventDefault();
        runValidation();
      }
    });

    if (shouldAutoOpen()) {
      window.setTimeout(function () {
        openModal();
        markAutoOpenShown();
      }, 700);
    }
  }

  // Arrancar después de que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
